export const isDashboardPath = (pathname: string) =>
  pathname === '/my-stories'
  || pathname === '/create'
  || pathname === '/create/detail'
  || pathname === '/create/confirm'
  || pathname.startsWith('/create-next-chapter/')
  || pathname.startsWith('/story-preview/')
  || pathname === '/characters'
  || pathname === '/characters/new'
  || pathname.startsWith('/characters/')
  || pathname.startsWith('/voices')
  || pathname === '/settings'
  || pathname === '/usage'
  || pathname === '/usage/how-tokens-work'
  || pathname === '/buy-tokens'
  || pathname === '/manage-subscription'
  || pathname.startsWith('/edit-story/')
  || pathname === '/notifications'
  || pathname === '/social-accounts'
  || pathname === '/publishing-results'
  || pathname === '/share'
  || pathname === '/download'
  || pathname.startsWith('/book-builder')
  || pathname === '/my-orders'
  || pathname.startsWith('/my-orders/')
  || pathname === '/support';
